import { render, staticRenderFns } from "./BeiguoSpecs.vue?vue&type=template&id=6336fd1c&scoped=true"
import script from "./BeiguoSpecs.vue?vue&type=script&lang=js"
export * from "./BeiguoSpecs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6336fd1c",
  null
  
)

export default component.exports